import {
  Button,
  Col,
  DatePicker,
  Pagination,
  Popover,
  Row,
  Select,
  Skeleton,
  Table,
} from "antd";
import { useEffect, useState } from "react";
import { FaEye } from "react-icons/fa";
import { MdTune } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { IoIosArrowRoundBack } from "react-icons/io";
import { useSelector } from "react-redux";
import { Get } from "../../config/api/get";
import { CARS } from "../../config/constants/api";
import moment from "moment";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

const ExistingCarRequest = () => {
  dayjs.extend(timezone);
  dayjs.extend(utc);
  const [loading, setLoading] = useState(false);
  const token = useSelector((state) => state.user.userToken);
  const [requests, setRequests] = useState(null);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const [paginationConfig, setPaginationConfig] = useState({
    pageNumber: 1,
    limit: 10,
    totalDocs: 0,
    totalPages: 0,
  });
  const [filter, setFilter] = useState({
    status: null,
    type: null,
    keyword: "",
    from: null,
    to: null,
  });
  const getUsers = (pageNumber, pageSize, from, to, status) => {
    setLoading(true);
    Get(CARS.getUpdateRequests, token, {
      from,
      to,
      status,
      page: pageNumber
        ? pageNumber.toString()
        : paginationConfig.pageNumber.toString(),
      limit: pageSize ? pageSize.toString() : paginationConfig.limit.toString(),
    })
      .then((response) => {
        if (response?.data?.docs) {
          setRequests(response?.data?.docs);
          setPaginationConfig({
            pageNumber: response?.data?.page,
            limit: response?.data?.limit,
            totalDocs: response?.data?.totalDocs,
            totalPages: response?.data?.totalPages,
          });
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log("Error Fetching Loads", err);
        setLoading(false);
      });
  };
  useEffect(() => {
    getUsers();
    // eslint-disable-next-line
  }, []);
  const startIndex =
    (paginationConfig.pageNumber - 1) * paginationConfig.limit + 1;
  const endIndex = Math.min(
    startIndex + paginationConfig.limit - 1,
    paginationConfig.totalDocs
  );
  const message = requests
    ? `Showing records ${endIndex} of ${paginationConfig.totalDocs}`
    : "Showing records 0 of 0";

  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return (
        <button type="button" className="pagination-link">
          Previous
        </button>
      );
    }
    if (type === "next") {
      return (
        <button type="button" className="pagination-link">
          Next
        </button>
      );
    }
    return originalElement;
  };
  const handleOpenChange = (newOpen) => {
    setOpen(newOpen);
  };

  const handlePageChange = (pageNumber) => {
    setPaginationConfig({
      ...paginationConfig,
      pageNumber: pageNumber,
    });
    getUsers(pageNumber, paginationConfig.limit);
  };

  const handleFrom = (date) => {
    setFilter({
      ...filter,
      from: date,
    });
  };

  const handleTo = (date) => {
    setFilter({
      ...filter,
      to: date,
    });
  };
  const data = {
    status: filter.status,
    keyword: filter.keyword,
    from: filter.from,
    to: filter.to,
  };
  const handleApply = () => {
    let from;
    let to;
    let status = filter.status;
    if (data.from) {
      from = moment(filter?.from?.$d).format("YYYY-MM-DD");
    }
    if (data.to) {
      to = moment(filter?.to?.$d).format("YYYY-MM-DD");
    }
    if (from || to || status) {
      getUsers(
        paginationConfig.pageNumber,
        paginationConfig.limit,
        from,
        to,
        status
      );
    } else {
      return;
    }
  };
  const resetFilter = () => {
    setFilter({
      status: null,
      keyword: "",
      from: null,
      to: null,
    });
  };
  const handleClear = () => {
    resetFilter();
    getUsers();
  };
  const handleStatusChange = (value) => {
    setFilter({
      ...filter,
      status: value,
    });
  };
  const filterContent = (
    <div className="filterDropdown">
      <div>
        <p
          className="mainLabel"
          style={{ padding: "10px", fontSize: "18px", fontWeight: "bold" }}
        >
          Filter
        </p>
      </div>
      <hr style={{ marginBottom: 10 }} />

      <div className="filterDropdownBody">
        <p className="mainLabel">From:</p>
        <DatePicker
          className="mainInput filterInput web-input"
          value={filter.from}
          onChange={(e) => handleFrom(e)}
          style={{ width: "100%" }}
        />
        <p className="mainLabel">To:</p>
        <DatePicker
          className="mainInput filterInput web-input"
          value={filter.to}
          onChange={(e) => handleTo(e)}
          style={{ width: "100%" }}
        />

        <p className="mainLabel"> Status:</p>

        <Select
          size={"large"}
          className="filterSelectBox"
          placeholder="Select Status"
          value={filter.status}
          onChange={(e) => handleStatusChange(e)}
          style={{
            width: "100%",
            marginBottom: "10px",
            textAlign: "left",
          }}
          options={[
            { value: "PENDING", label: "Pending" },
            { value: "APPROVED", label: "Approved" },
            { value: "REJECTED", label: "Rejected" },
          ]}
        />

        <Button
          type=""
          block
          size={"large"}
          style={{ marginBottom: "10px" }}
          className="web-btn"
          //   onClick={() => getUsers()}
          onClick={handleApply}
        >
          Apply
        </Button>
        <Button
          type=""
          block
          size={"large"}
          className="web-btn"
          onClick={handleClear}
        >
          Clear All
        </Button>
      </div>
    </div>
  );
  const columns = [
    {
      title: (
        <p className="uppercase font-euclid text-black font-bold text-xs text-center">
          S.NO
        </p>
      ),
      dataIndex: "key",
      key: "key",
      render: (value, item, index) => (
        <p className="text-xs text-center font-euclid text-[#575757]">
          {(index < 10 && "0") + (index + 1)}
        </p>
      ),
    },
    {
      title: (
        <p className="uppercase font-euclid text-black font-bold text-xs text-center">
          Car Name
        </p>
      ),
      dataIndex: ["car", "name"],
      key: "name",
      render: (value, item, index) => (
        <p className="text-xs text-center font-euclid text-[#575757]">
          {item?.car?.name}
        </p>
      ),
    },
    {
      title: (
        <p className="uppercase font-euclid text-black font-bold text-xs text-center">
          Chauffeur Name
        </p>
      ),
      dataIndex: ["chauffeur", "name"],
      key: "driverName",
      render: (value, item, index) => (
        <p className="text-xs text-center font-euclid text-[#575757]">
          {item.chauffeur?.firstName + " " + item.chauffeur?.lastName}
        </p>
      ),
    },
    {
      title: (
        <p className="uppercase font-euclid text-black font-bold text-xs text-center">
          Car Model
        </p>
      ),
      dataIndex: ["car", "model"],
      key: "carModel",
      render: (value, item, index) => (
        <p className="text-xs text-center font-euclid text-[#575757]">
          {item.car?.model}
        </p>
      ),
    },

    {
      title: (
        <p className="uppercase font-euclid text-black font-bold text-xs text-center">
          Car number
        </p>
      ),
      dataIndex: ["car", "carNumber"],
      key: "carNumber",
      render: (value, item, index) => (
        <p className="text-xs text-center font-euclid text-[#575757]">
          {item.car.carNumber}
        </p>
      ),
    },
    {
      title: (
        <p className="uppercase font-euclid text-black font-bold text-xs text-center">
          registeration date
        </p>
      ),
      dataIndex: "createdAt",
      key: "createdAt",
      render: (item) => <span>{dayjs.tz(item, "UTC").format("M/D/YYYY")}</span>,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (item) => (
        <>
          {item === "PENDING" ? (
            <span style={{ color: "#DD9F00" }}>{item}</span>
          ) : item === "REJECTED" ? (
            <span style={{ color: "#ff0000" }}>{item}</span>
          ) : item === "APPROVED" ? (
            <span style={{ color: "#00D640" }}>{item}</span>
          ) : (
            <span>{item}</span>
          )}
        </>
      ),
    },
    {
      title: (
        <p className="uppercase font-euclid text-black font-bold text-xs text-center">
          action
        </p>
      ),
      dataIndex: "_id",
      key: "_id",
      render: (value, item) => (
        <div className="flex justify-center">
          <div className="flex justify-center bg-[#FDE6C3] rounded-[100%] w-fit p-2 mr-1">
            <FaEye
              className="text-[#CD810D] cursor-pointer h-[16px] w-[16px]"
              onClick={() =>
                navigate("/carUpdateRequest/" + item._id, {
                  state: { request: item },
                })
              }
            />
          </div>
        </div>
      ),
    },
  ];
  return (
    <Row justify="center">
      <Col md={23} xs={22}>
        <div className="flex justify-between items-center my-8">
          <div className="flex justify-center items-center">
            <IoIosArrowRoundBack
              onClick={() => navigate(-1)}
              className="self-center cursor-pointer mr-1 w-[48px] h-[48px] max-sm:w-[24px] max-sm:h-[24px] text-black"
            />
            <h3 className="font-tavi laptop:text-3xl text-lg font-normal text-black">
              Car Update Request
            </h3>
          </div>

          <div className="flex justify-center items-center">
            &emsp;
            <div className="flex justify-center">
              <Popover
                content={filterContent}
                trigger="click"
                open={open}
                onOpenChange={handleOpenChange}
                placement="bottomRight"
                arrow={false}
              >
                <Button
                  style={{
                    padding: "4px 11px",
                    height: "auto",
                    borderRadius: "6px",
                    backgroundColor: "white",
                  }}
                >
                  <MdTune className="max-xl:text-[24px] text-[32px] text-[#767676]" />
                </Button>
              </Popover>
            </div>
          </div>
        </div>
        <div
          className="bg-white rounded-lg  py-8 my-8"
          style={{ boxShadow: "1px 1px 1px 1px rgba(0, 0, 0, 0.05)" }}
        >
          <Row style={{ overflow: "auto" }} className="px-6">
            {loading ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <Skeleton active />
                <br />
              </div>
            ) : (
              <Table
                className="styledTable"
                dataSource={requests}
                columns={columns}
                pagination={false}
              />
            )}
          </Row>
          <Row style={{ padding: "10px 20px" }}>
            <Col xs={24} md={12}>
              <p className="font-euclid text-sm text-black">{message}</p>
            </Col>
            <Col
              xs={24}
              md={12}
              style={{ display: "flex", justifyContent: "flex-end" }}
            >
              <Pagination
                className="styledPagination"
                onChange={(e) => handlePageChange(e)}
                current={parseInt(paginationConfig.pageNumber)}
                pageSize={paginationConfig.limit}
                total={paginationConfig.totalDocs}
                itemRender={itemRender}
              />
            </Col>
          </Row>
        </div>
      </Col>
    </Row>
  );
};

export default ExistingCarRequest;
